
import { mapGetters } from 'vuex'
import * as ov from '@/constants/constants'

export default {
    props: [
        'h1',
        'metatitle',
        'metadesc',
        'narrators',
        'page',
        'total_pages',
        'text',
        'filterpage',
    ],

    data() {
        return {
            var_h1: null,
            var_metatitle: null,
            var_metadesc: null,
            var_narrators: null,
            var_page: 1,
            var_total_pages: null,
            var_text: '',
            var_name: '',

            filters_shown: this.filterpage ?? 0,
            active_genre: this.filterpage && this.filterpage.hasOwnProperty('genres_id') ? this.filterpage.genres_id : 0,
            filter_genders: this.filterpage && this.filterpage.hasOwnProperty('genders_id') && (this.filterpage.genders_id !== null) ? [this.filterpage.genders_id] : [],
            filter_ages: this.filterpage && this.filterpage.hasOwnProperty('ages_id') && (this.filterpage.ages_id !== null) ? [this.filterpage.ages_id] : [],
            filter_timbres: this.filterpage && this.filterpage.hasOwnProperty('timbres_id') && (this.filterpage.timbres_id !== null) ? [this.filterpage.timbres_id] : [],
            filter_language: this.filterpage && this.filterpage.hasOwnProperty('languages_id') ? this.filterpage.languages_id : 0,
            filter_native: this.filterpage && this.filterpage.hasOwnProperty('native') ? this.filterpage.native : false,
            filter_topic: 0,

            filter_sort: 0,
            timerBeforeGetNarrators: null,

            may_show_narrators: false,
        };
    },

    computed: {
        ...mapGetters(['appInfo']),
        ov() {
            return ov
        },

        mayShowNarrators() {
            return this.may_show_narrators
        },
    },

    methods: {
        onUpdateFilter(data) {
            // console.log('onUpdateFilter')
            this.var_page = 1
            this.active_genre = data.filter_genre
            this.filter_genders = data.filter_genders
            this.filter_ages = data.filter_ages
            this.filter_timbres = data.filter_timbres
            this.filter_language = data.filter_language
            this.active_genre = data.filter_genre
            this.filter_topic = data.filter_topic
            this.filter_native = data.filter_native
            this.filter_sort = data.filter_sort
            this.var_name = data.filter_name

            this.getNarrators()
        },

        getNarrators() {
            clearTimeout(this.timerBeforeGetNarrators);
            this.timerBeforeGetNarrators = setTimeout(() => {
                var params = {
                    page: this.var_page,
                    genre: this.active_genre,
                    gender: this.filter_genders,
                    age: this.filter_ages,
                    timbre: this.filter_timbres,
                    // topic: this.filter_topic,
                    language: this.filter_language,
                    native: +this.filter_native,
                    name: this.var_name,
                    sort: + this.filter_sort,
                    withCredentials: true,
                }

                this.$axios
                    .get('/narrators', {
                        params
                    })
                    .then((res) => {
                        // console.log(res.data.url)
                        if (res.data.url) {
                            if (res.data.url.includes('&')) {
                                history.pushState(null, null, this.localePath('narrators') + '?' + res.data.url)
                            } else {
                                history.pushState(null, null, this.localePath('narrators-filter') + '/' + res.data.url)
                            }
                            document.title = res.data.metatitle
                        }
                        else {
                            history.pushState(null, null, this.localePath('narrators'))
                            document.title = this.metatitle
                        }

                        if (this.var_page > 1) {
                            this.var_narrators = this.var_narrators.concat(res.data.narrators)
                        }
                        else this.var_narrators = res.data.narrators

                        this.var_total_pages = res.data.total_pages
                        this.var_h1 = res.data.h1
                        this.var_text = res.data.text

                        this.may_show_narrators = true
                    })
            }, 500);
        },

        setActiveGenre(id) {
            this.active_genre = id
            this.$root.$emit('set_active_genre', id)
        },
    },

    created() {
        this.var_h1 = this.h1
        this.var_metatitle = this.metatitle
        this.var_metadesc = this.metadesc
        this.var_text = this.text
        this.var_page = this.page ?? 1
        this.var_total_pages = this.total_pages
        this.var_narrators = this.narrators

        this.$root.$on('close_filter', () => {
            this.filters_shown = 0
        })

        this.$root.$on('set_saved_filters', (data) => {
            // console.log('root set_saved_filters')
            this.$root.$emit('set_filters', data)
        })

        this.$root.$on('go_without_filters', (data) => {
            // console.log('root go_without_filters')
            this.may_show_narrators = true
        })
    },

    beforeDestroy() {
        this.$root.$off('close_filter')
        this.$root.$off('set_saved_filters')
        this.$root.$off('go_without_filters')
    },

    watch: {
        var_name: function (val, oldVal) {
            this.var_name = val.trim()
        },
    },
}
